<template>
  <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
    <v-card-text>
      <v-container grid-list-md style="min-width: 100%;" class="pa-0">
        <v-layout wrap>
          <v-flex xs6>
            <v-text-field
              class="text-field-reducido-border"
              type="date"
              label="Fecha de retiro"
              v-model="form.fecha_desde"
              :rules="$validate(['required'])"
              required
              :error-messages="errors"
              @input="esFeriadoOFinDeSemana(form.fecha_desde, 1)"
              @change="alertarAprobacion()"
              outline
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <small class="error--text text-required"
        >* Los campos son obligatorios</small
      >
      <v-spacer></v-spacer>
      <v-btn @click.native="close()">
        <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
      </v-btn>
      <v-btn
        v-show="!fecha_futuro"
        color="primary"
        type="submit"
        :loading="loading"
        :disabled="!valid || !data.id_tipo_justificacion_r"
      >
        <v-icon dark>check</v-icon> {{ $t("common.save") }}
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  mixins: [validate],
  props: ["id_tipo_justificacion", "funcionario", "data"],
  data() {
    return {
      valid: false,
      loading: false,
      form: this.data,
      errors: [],
      fecha_futuro: false,
      bandera_fecha: false
    };
  },
  mounted() {
    this.fijarDatosFuncionario();
  },
  methods: {
    alertarAprobacion() {
      // Estado programado
      if (this.form.id_estado == 64) {
        if (
          this.$moment() >= this.$moment(this.form.fecha_desde, "YYYY-MM-DD")
        ) {
          this.$alert(
            "Selecciono la fecha actual o una fecha pasada, por lo tanto la movilidad se aprobara si la guarda"
          );
        }
      }
      // Estado Alta o alta temporal
      if (this.form.id_estado == 1 || this.form.id_estado == 53) {
        if (
          this.$moment() <= this.$moment(this.form.fecha_desde, "YYYY-MM-DD")
        ) {
          this.$alert(
            "Selecciono una fecha a futuro, por lo cual no puede guardar la movilidad, ya que fue aprobada"
          );
          this.fecha_futuro = true;
        } else {
          this.fecha_futuro = false;
        }
      }
    },
    async esFeriadoOFinDeSemana(fecha, valor) {},
    async esFeriadoOFinDeSemanaVerificar(fecha, valor) {
      try {
        if (valor == 1) {
          this.bandera_fecha = false;
        }
        let usuario = this.$storage.get("user");
        if (!fecha && valor == 1) {
          this.$message.info("Fecha inválida ", fecha);
          this.bandera_fecha = true;
          return true;
        } else {
          //verificando que la fecha es o no dia habil
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta: "SELECT general.fn_cuenta_finde_feriado_por_persona('${fecha}', '${fecha}', ${usuario.id_persona})"){
                  respuesta
                }
              }
            `
          });
          if (respuesta.runQuery.respuesta) {
            respuesta =
              respuesta.runQuery.respuesta[0]
                .fn_cuenta_finde_feriado_por_persona;

            if (respuesta == 1 && valor == 1) {
              this.$message.info(
                `La fecha ${this.$moment(fecha).format(
                  "DD/MM/YYYY"
                )} cae en fin de semana o feriado`
              );
              this.bandera_fecha = true;
              return true;
            }

            return false;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async save() {
      let validacion_fecha = await this.esFeriadoOFinDeSemanaVerificar(
        this.form.fecha_desde,
        1
      );
      if (validacion_fecha) {
        return;
      }
      if (this.form.editar) {
        try {
          if (this.$refs.form.validate()) {
            this.loading = true;
            let id_puesto = this.form.id_puesto;
            let id_cargo = this.form.id_cargo;
            let id_tipo_justificacion = this.form.id_tipo_justificacion_r;
            let user = this.$storage.get("user");
            let res = await this.$service.graphql({
              query: `
                query{
                 runQuery(consulta: "SELECT movilidad.fn_modifica_movilidad_interinato_estado(${this.funcionario.id_persona}, ${user.id}, '${this.form.fecha_desde}', ${this.form.id_unidad}, ${id_puesto}, ${id_cargo}, ${this.form.nro_item}, ${id_tipo_justificacion},'${this.form.fecha_desde}',${this.form.id_estado})"){
                    respuesta
                  }
                }
              `
            });
            res =
              res.runQuery.respuesta[0].fn_modifica_movilidad_interinato_estado;

            let resps = res.split("|");
            let correcto = resps[0];

            if (correcto === "1") {
              this.$message.success(resps);
              this.close();
            } else {
              this.$message.error(resps);
              this.loading = false;
            }
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          if (this.$refs.form.validate()) {
            let user = this.$storage.get("user");
            this.loading = true;
            let res = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta: "SELECT movilidad.fn_retiro_movilidad(${this.funcionario.id_persona}, ${user.id}, ${this.id_tipo_justificacion}, '${this.form.fecha_desde}', '${this.form.nro_memorandum}')"){
                    respuesta
                  }
                }
              `
            });
            let resp = res.runQuery.respuesta[0].fn_retiro_movilidad;

            let resps = resp.split("|");
            let correcto = resps[0];
            if (correcto === "1") {
              this.$message.success();
              this.loading = false;
            } else {
              this.$message.error(resps);
              this.loading = false;
            }
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
    },

    // validaFecha() {
    //   var feha = new Date(this.form.fecha_desde);
    //   var dayOfWeek = feha.getDay();
    //   if (
    //     (dayOfWeek === 5 || dayOfWeek === 6) &&
    //     this.id_tipo_justificacion !== 10
    //   ) {
    //     this.errors.push("El tipo de retiro no admite fines de semana");
    //   } else {
    //     this.errors = [];
    //   }
    // },

    close() {
      this.form = {};
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogCrearMovilidad");
    },
    fijarDatosFuncionario() {
      if (
        this.id_tipo_justificacion === 5 ||
        this.id_tipo_justificacion === 6 ||
        this.id_tipo_justificacion === 10
      ) {
        this.form.id_tipo_justificacion = this.form.id_tipo_justificacion;
        this.form.id_tipo_justificacion_r = this.form.id_tipo_justificacion_r;
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/movilidad/components/Retiro.vue